import Image from "next/image";
import styles from "./banner.module.css";

export default function Banner({ data }) {
  return (
    <div className={`${styles.bg} container-full`}>
      <Image
        src={data.imagem.url}
        alt="A Realiza"
        layout="fill"
        objectFit="cover"
        objectPosition="center"
      />
      <div className={styles.content}>
        <div className={styles.logos_img}>
          <img
            src={data.logos.logo_programa.url}
            alt="logo Minha Casa Minha Vida"
          />
          <img src={data.logos.logo_caixa.url} alt="logo caixa" />
        </div>
        <div className={styles.title}>
          <span>{data.titulo}</span>
        </div>
      </div>
    </div>
  );
}
